import {z} from '@hono/zod-openapi';

export const nissanDiglasCommitSourceSchema = z
  .union([
    z.object({sourceFormat: z.null()}),
    z.object({
      sourceFormat: z.literal('NISSAN_DIGLAS'),
      sourceIdentity: z.string().min(1),
      fingerprint: z.string().regex(/^[a-f0-9]{64}$/),
      invoiceNumber: z.string(),
      invoiceIssueDate: z.string().date(),
      currency: z.literal('CZK'),
      supplierTaxId: z.string(),
      customerTaxId: z.string(),
      lines: z
        .array(
          z.object({
            lineNumber: z.number().int().positive(),
            partNumber: z.string(),
            quantity: z.string(),
            unitPrice: z.string(),
            netAmount: z.string(),
          })
        )
        .min(1),
    }),
  ])
  .openapi('NissanDiglasCommitSource');
export type NissanDiglasCommitSource = z.infer<typeof nissanDiglasCommitSourceSchema>;
